import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, ActionSelector,
  HeaderLabel, CellText, TypeSelector,
} from '../../../components/truckowner-components'
import { theme } from '../../../styles/_variables'
import { ownerTypesObj } from '../../truck-page/constants'

const convertTruckType = (value) => {
  switch (value) {
    case ownerTypesObj.PADOONGRICH:
      return ownerTypesObj.PADOONGRICH_TH
    case ownerTypesObj.JOINTCAR:
      return ownerTypesObj.JOINTCAR_TH
    case ownerTypesObj.OUTJOINTCAR:
      return ownerTypesObj.OUTJOINTCAR_TH
    default:
      return 'ไม่ระบุ'
  }
}
const { color } = theme

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          รหัสเจ้าของรถ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'code',
    sortable: true,
    filterable: true,
    Cell: props => <CellText bold>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.code, filter.value),
    width: 130,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          Owner Name <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'nameEn',
    Cell: props => (
      <Tooltip placement="top" title={props.value}>
        <CellText textAlign='center'>{props.value}</CellText>
      </Tooltip>
    ),
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.nameEn, filter.value),
    sortable: true,
    filterable: true,
    width: 220,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อเจ้าของรถ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'nameTh',
    sortable: true,
    filterable: true,
    Cell: props => (
      <Tooltip placement="top" title={props.value}>
        <CellText textAlign='center'>{props.value}</CellText>
      </Tooltip>
    ),
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.nameTh, filter.value),
    width: 220,
  }, {
    Header: <HeaderLabel>ประเภท</HeaderLabel>,
    accessor: 'type',
    sortable: false,
    filterable: true,
    Cell: props => <CellText bold>{convertTruckType(props.value)}</CellText>,
    filterMethod: (filter, row) => filter.value === row.type || filter.value === 'ALL',
    Filter: ({ onChange }) => <TypeSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
    width: 155,
  }, {
    Header: <HeaderLabel>ค่าธรรมเนียม</HeaderLabel>,
    accessor: 'rate',
    sortable: false,
    filterable: false,
    Cell: props => <CellText bold>{props.value} %</CellText>,
    filterMethod: (filter, row) => filter.value === row.type || filter.value === 'ALL',
    Filter: ({ onChange }) => <TypeSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
    width: 100,
  }, {
    Header: <HeaderLabel>เลขที่ผู้เสียภาษี</HeaderLabel>,
    accessor: 'taxId',
    sortable: false,
    filterable: false,
    Cell: props => <CellText bold>{props.value}</CellText>,
    width: 100,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 160,
  },
  ],
}
